import { idbGet, idbRemove, idbSet } from "@/shared/IndexedDBHelper";
import { SyncStatus } from "@/shared/sync/dataTypes/SyncStatus";

type TempStatusRecord = Record<string, SyncStatus>;

export class CloudUploadTempDataManager {
    private static readonly storageKey = "kCloudUploadingStatuses";
    private static instance: CloudUploadTempDataManager;

    private statuses = new Map<string, SyncStatus>();
    private didSetup = false;

    static get shared(): CloudUploadTempDataManager {
        if (!CloudUploadTempDataManager.instance) {
            CloudUploadTempDataManager.instance = new CloudUploadTempDataManager();
        }
        return CloudUploadTempDataManager.instance;
    }

    private constructor() {}

    async setup() {
        if (this.didSetup) return;

        const rawStatuses = await idbGet<string>(CloudUploadTempDataManager.storageKey);
        if (rawStatuses) {
            try {
                const parsedStatuses: TempStatusRecord = JSON.parse(rawStatuses);
                this.statuses = new Map<string, SyncStatus>(Object.entries(parsedStatuses));
            } catch (error) {
                console.warn("sync: failed to load temp uploading statuses", error);
            }
        }

        this.didSetup = true;
    }

    async setStatus(projectId: string, status: SyncStatus) {
        if (!projectId) return;

        await this.setup();

        this.statuses.set(projectId, status);
        await this.persist();
    }

    async getStatuses(): Promise<Map<string, SyncStatus>> {
        await this.setup();
        return new Map(this.statuses);
    }

    async clear() {
        this.statuses.clear();
        await idbRemove(CloudUploadTempDataManager.storageKey);
        this.didSetup = true;
    }

    private async persist() {
        const data: TempStatusRecord = {};
        this.statuses.forEach((status, projectId) => {
            data[projectId] = status;
        });

        await idbSet(CloudUploadTempDataManager.storageKey, JSON.stringify(data));
    }
}
